import {Fragment, useEffect, useState} from 'react';
import cn from 'classnames';
import ReactMarkDown from 'react-markdown';
import styles from './bonus.module.scss';
import { IBonus } from '../../../interfaces/bonus.interface';
import defaultBonusImage from '../../../assets/img/default-gift.png';
import { appConfig } from '../../../config/app.config';
import { useMediaQuery } from 'react-responsive';

interface BonusProps {
	bonus:IBonus, 
	active:boolean, 
  mode?: "inline" | "block"; 
  count: number;
}

export default function Bonus({bonus, mode = "inline", active, count }: BonusProps) {
  const imageUrl = bonus.image?.url ? appConfig().assets_url + bonus.image?.url : defaultBonusImage;
  const fromMobile = useMediaQuery({ maxWidth: 768 });
  const [ imagePrefix, setImagePrefix ] = useState("");

  useEffect(() => {
    if (mode == "block" || fromMobile) {
      setImagePrefix("mini_");
      return;
    } else setImagePrefix("");

  }, [mode, fromMobile, setImagePrefix]);

	return <li 
    style={{ backgroundColor: bonus.backgroundColor }}
    className={cn(
      styles.bonus, 
      [styles[mode]], 
      styles[`type_${bonus.type}`], 
      { [styles.count_1]: count == 1 && fromMobile, [styles.count_2]: count == 2 && fromMobile}
    )}
  >
    <div className={styles.container}>
      <h3 style={{ color: bonus.lightThemeFontColor }}>
        <ReactMarkDown 
          source={bonus.title}
          escapeHtml={false}
          renderers={{ paragraph: ({ children }) => <Fragment children={children}/> }}
          /> 
      </h3>

      {bonus.description && <p>
        <ReactMarkDown
          source={bonus.description}
          escapeHtml={false}
          renderers={{ paragraph: ({ children }) => <Fragment children={children} /> }}
          />
      </p>}

      {bonus.image ? <img className={styles.customImage} style={bonus.imageStyle} src={imageUrl} alt="Бонус"/> 
      : <img alt="" className={styles.image} src={appConfig().assets_url + appConfig().bonuses_path + `${imagePrefix}bonus_${bonus.type}.png`}/>}
    </div>
		<div className={cn(styles.icon, styles.lock, { [styles['icon-active']]: active })}></div>
	</li>
}